import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import DevelopmentSection from './components/DevelopmentSection';
import TechnicalConsultingSection from './components/TechnicalConsultingSection';
import ContactSection from './components/ContactSection';
import './index.css'; // Nur diese CSS-Datei wird noch benötigt
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import AGB from './pages/AGB';


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>

          <Route
            path="/"
            element={
              <>
                <HeroSection />
                <DevelopmentSection />
                <TechnicalConsultingSection />
                <ContactSection />
              </>
            }
          />

          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />

        </Routes>
      </div>
    </Router>
  );
}
export default App;
